<div *ngIf="!loading" class="modal-content">
  <div class="modal-header">
    <a (click)="$event.preventDefault(); downloadEmail(this.EmailSent)" href="#" class="pe-auto">Download Email</a>
    <button type="button" class="close pull-right" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="flex d-flex mb-3 mx-4 content-margin">
      <div><span class="mr-2 ml-4 mb-4 font-color">From:</span>{{ productType.emailSender }}</div>
      <div class="ml-4"><span class="ml-4 mr-2 mb-4 font-color">Reply-To:</span>{{ productType.emailReplyTo }}</div>
    </div>
    <div>
      <form class="content-margin">
        <div class="mb-2">
          <div class="form-group mb-0 d-flex flex mx-4">
            <label class="font-color mr-4 mt-1" for="emailTo">To:</label>
            <input id="emailTo" [value]="this.EmailSent.to" disabled class="form-control" />
          </div>
        </div>
        <div class="mb-2">
          <div class="form-group mb-0 d-flex flex mx-4">
            <label class="font-color mr-4 mt-1" for="emailTo">Cc:</label>

            <input id="emailTo" [value]="this.EmailSent.cc" disabled class="form-control" />
          </div>
        </div>
        <div class="mb-2">
          <div class="form-group mb-0 d-flex flex mx-4">
            <label class="font-color mr-4 mt-1" for="subject">Subject:</label>

            <input id="subject" [value]="this.EmailSent.subject" disabled class="form-control" />
          </div>
        </div>
        <div class="content">
          <div [innerHTML]="this.emailContent"></div>
        </div>
      </form>
    </div>
  </div>
</div>

<div *ngIf="loading" class="spinner-grid-size">
  <ngx-loading
    [show]="loading"
    [config]="{
      backdropBorderRadius: '3px',
      animationType: ngxLoadingAnimationTypes.circle,
      primaryColour: this.primaryColour,
      secondaryColour: this.secondaryColour
    }">
  </ngx-loading>
</div>
